export default "__VITE_ASSET__BsiifbON__"